export const iconFontAwesomeShapesCircleHalfStroke = (
	<i className="fa-solid fa-circle-half-stroke"></i>
);
